import type { WidgetTone } from '../types'

type ToneStyle = { icon: string; swatch: string; bar: string; text: string }

export const TONE_STYLES: Record<WidgetTone, ToneStyle> = {
  primary: { icon: 'bg-primary/10 text-primary ring-primary/15', swatch: 'bg-primary', bar: 'bg-primary', text: 'text-primary' },
  success: { icon: 'bg-success/12 text-success ring-success/20', swatch: 'bg-success', bar: 'bg-success', text: 'text-success' },
  violet: { icon: 'bg-violet/12 text-violet ring-violet/20', swatch: 'bg-violet', bar: 'bg-violet', text: 'text-violet' },
  orange: {
    icon: 'bg-brand-orange/12 text-brand-orange ring-brand-orange/20',
    swatch: 'bg-brand-orange',
    bar: 'bg-brand-orange',
    text: 'text-brand-orange',
  },
  danger: {
    icon: 'bg-destructive/10 text-destructive ring-destructive/20',
    swatch: 'bg-destructive',
    bar: 'bg-destructive',
    text: 'text-destructive',
  },
  neutral: {
    icon: 'bg-muted text-muted-foreground ring-border',
    swatch: 'bg-muted-foreground/50',
    bar: 'bg-muted-foreground/60',
    text: 'text-muted-foreground',
  },
}

export const widgetCardClass = 'relative flex h-full min-h-0 flex-col rounded-2xl border bg-card shadow-card transition-shadow duration-200 hover:shadow-card-hover'
